import { COMMON_OFFERS } from '@sravni/ugc/lib/specialOffers/lists';

export const OFFERS_TYPES = {
  ...COMMON_OFFERS,
  autocredits: 'autocredits',
};
